var map = {
	"./17-cn.webp": 1288,
	"./17.webp": 1289,
	"./27-cn.webp": 1290,
	"./27.webp": 1291,
	"./7-cn.webp": 1292,
	"./7.webp": 1293,
	"./angpao-bg-mobile.jpg": 1294,
	"./angpao-bg.jpg": 1295,
	"./angpao-cn.webp": 1296,
	"./angpao.webp": 1297,
	"./button.png": 1298,
	"./close-eye.png": 1299,
	"./coin-1.png": 1300,
	"./coin.png": 1301,
	"./ketupak-open.png": 1302,
	"./ketupak.png": 1303,
	"./ketupak_ribbon.png": 1304,
	"./rain-1.png": 1305,
	"./rain-2.png": 1306,
	"./rain-3.png": 1307,
	"./raya-bg-mobile.png": 1308,
	"./raya-bg.png": 1309,
	"./shine.png": 1310,
	"./star-1.png": 1311,
	"./star-2.png": 1312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 364;